export default "__VITE_ASSET__Cyrd00az__"